import React from 'react'
import { Dialog, Button } from '@leverege/ui-elements'

import S from './AddDialog.css'

/**
 * @class AddDialog — A dialog component for adding a new oidc client
 * @component 
 */
export default class AddDialog extends React.Component {

  constructor( props ) {
    super( props )
    this.state = { model : props.creator.create() }
  }

  static getDerivedStateFromProps( props, state ) {
    if ( props.show === false && props.creator ) {
      return { model : props.creator.create() }
    }
    return null
  }

  /**
   * @method onChange 
   * @param {object} evt A change event from the Editor 
   */
  onChange = ( evt ) => {
    this.setState( { model : evt.value } )
  }

  /**
   * @method onCreate 
   * @param {object} item 
   */
  onCreate = ( item ) => {
    const { model } = this.state
    const { onCreate } = this.props
    if ( typeof onCreate === 'function' ) {
      onCreate( model )
    }
  }

  render() {
    const { title, editor : Editor, onClose, show } = this.props
    const { model } = this.state

    return (
      <Dialog show={show} title={title} footer={<Footer onCreate={this.onCreate} onClose={onClose} />} onClose={onClose}>
        <Editor value={model} onChange={this.onChange}/>
      </Dialog>
    )
  }
}

/**
 * @function Footer 
 * @component 
 * @property {function} onCreate Create a new oidc client 
 * @property {function} onClose Cancel adding a new oidc client 
 */
function Footer( props ) {
  const { onCreate, onClose } = props

  return (
    <div className={S.footer}>
      <Button variant="secondary" onClick={onClose}>Cancel</Button>
      <Button variant="primary" onClick={onCreate}>Create</Button>
    </div>
  )
}
